import { DateValidator } from './../../classes/validators/date-validator';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Device, DeviceInfo } from 'src/app/classes';
import { DeviceInfoService } from 'src/app/services/deviceInfo.service';
import { WidgetsmanagerService } from 'src/app/services/widgetsmanager.service';

@Component({
  selector: 'app-edit-device-info',
  templateUrl: './edit-device-info.component.html',
  styleUrls: ['./edit-device-info.component.scss'],
})
export class EditDeviceInfoComponent implements OnInit {

  @Input('deviceInfo')
  public deviceInfo: DeviceInfo;

  @Input()
  public isReadOnly: boolean;

  @Input('closeEvent')
  public closeEvent: EventEmitter<any>;

  @Output('deviceInfoUpdated')
  public deviceInfoUpdated: EventEmitter<DeviceInfo>;

  public deviceInfoForm: FormGroup;
  public validation_messages: any;
  public loading = false;
  public selectedFile: File = null;
  public sourceFilename: string;

  constructor(
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private widgetsManager: WidgetsmanagerService,
    private _deviceInfoSvc: DeviceInfoService,
  ) { }

  ngOnInit() {
    this.deviceInfoForm = this.formBuilder.group({
      id: this.deviceInfo.id,
      name: this.deviceInfo.nameDevice,
      cityName: this.deviceInfo.cityName,
      deviceCategory: this.translate.instant(Device.getLabelDeviceType(this.deviceInfo.deviceCategory)),
      nameModel: this.deviceInfo.nameModel,
      frameNumber: [this.deviceInfo.frameNumber, [
        Validators.pattern('^[a-zA-Z0-9]*$')
      ]],
      plate: [this.deviceInfo.plate, [
        Validators.pattern('^[a-zA-Z0-9]*$')
      ]],
      historyPlate: [this.deviceInfo.historyPlate, [
        Validators.pattern('^[a-zA-Z0-9]*$')
      ]],
      cityscootPlate: [this.deviceInfo.cityscootPlate, [
        Validators.pattern('^[a-zA-Z0-9]*$')
      ]],
      policyNumber: this.deviceInfo.policyNumber,
      insuranceProvider: this.deviceInfo.insuranceProvider,
      insuranceDate: [this.deviceInfo.insuranceDate, [
        DateValidator.notTooOld(2015)
      ]],
      insuranceExpiryDate: [this.deviceInfo.insuranceExpiryDate, [
        DateValidator.notTooOld(2015)
      ]],
      insuranceDriverNumber: this.deviceInfo.insuranceDriverNumber,
      driverInsuranceDate: [this.deviceInfo.driverInsuranceDate, [
        DateValidator.notTooOld(2015)
      ]],
      driverInsuranceExpiryDate: [this.deviceInfo.driverInsuranceExpiryDate, [
        DateValidator.notTooOld(2015)
      ]],
      revisionExpiryDate: [this.deviceInfo.revisionExpiryDate, [
        DateValidator.notTooOld(2015)
      ]],
      ztlDate: [this.deviceInfo.ztlDate, [
        DateValidator.notTooOld(2015)
      ]],
      ztlExpiryDate: [this.deviceInfo.ztlExpiryDate, [
        DateValidator.notTooOld(2015)
      ]],
      placement: this.deviceInfo.placement,
      notes: this.deviceInfo.notes,
    },
    {
      validators:[
        DateValidator.startBeforeOrEqualEnd('insuranceDate', 'insuranceExpiryDate'),
        DateValidator.startBeforeOrEqualEnd('driverInsuranceDate', 'driverInsuranceExpiryDate'),
        DateValidator.startBeforeOrEqualEnd('ztlDate', 'ztlExpiryDate')
      ]
    }); 
    this.validation_messages = {
      frameNumber: [{type: 'pattern', message: 'The field can only contain letters and numbers without special characters.'}],
      plate: [{type: 'pattern', message: 'The field can only contain letters and numbers without special characters.'}],
      historyPlate: [{type: 'pattern', message: 'The field can only contain letters and numbers without special characters.'}],
      cityscootPlate: [{type: 'pattern', message: 'The field can only contain letters and numbers without special characters.'}],
      insuranceDate: [{type: 'tooOld', message: 'The insurance start date cannot be earlier than 2015.'}],
      insuranceExpiryDate: [
        {type: 'dateRangeInvalid', message: 'The insurance expiry date must be after or equal to the start date.'}, 
        {type: 'tooOld', message: 'The insurance expiry date cannot be earlier than 2015.'}
      ],
      driverInsuranceDate: [{type: 'tooOld', message: 'The driver insurance start date cannot be earlier than 2015.'}],
      driverInsuranceExpiryDate: [
        {type: 'dateRangeInvalid', message: 'The driver insurance expiry date must be after or equal to the start date.'},
        {type: 'tooOld', message: 'The driver insurance expiry date cannot be earlier than 2015.'},
      ],
      revisionExpiryDate: [{type: 'tooOld', message: 'The revision expiry date cannot be earlier than 2015.'}],
      ztlDate: [{type: 'tooOld', message: 'The ZTL start date cannot be earlier than 2015.'}],
      ztlExpiryDate: [
        {type: 'dateRangeInvalid', message: 'The ZTL expiry date must be after or equal to the start date.'},
        {type: 'tooOld', message: 'The ZTL expiry date cannot be earlier than 2015.'}
      ]
    };
  }
  
  update() {
    this.loading = true;
    this._deviceInfoSvc.getDeviceInfoDetail(this.deviceInfo.id).subscribe((res: DeviceInfo) => {
      this.deviceInfo = res;

       this.deviceInfoForm.patchValue({
         id: this.deviceInfo.id,
         deviceId: this.deviceInfo.deviceId,
         frameNumber: this.deviceInfo.frameNumber,
         plate: this.deviceInfo.plate,
         historyPlate: this.deviceInfo.historyPlate,
         cityscootPlate: this.deviceInfo.cityscootPlate,
         policyNumber: this.deviceInfo.policyNumber,
         insuranceProvider: this.deviceInfo.insuranceProvider,
         insuranceDate: this.deviceInfo.insuranceDate,
         insuranceExpiryDate: this.deviceInfo.insuranceExpiryDate,
         insuranceDriverNumber: this.deviceInfo.insuranceDriverNumber,
         driverInsuranceDate: this.deviceInfo.driverInsuranceDate,
         driverInsuranceExpiryDate: this.deviceInfo.driverInsuranceExpiryDate,
         revisionExpiryDate: this.deviceInfo.revisionExpiryDate,
         ztlDate: this.deviceInfo.ztlDate,
         ztlExpiryDate: this.deviceInfo.ztlExpiryDate,
         placement: this.deviceInfo.placement,
         notes: this.deviceInfo.notes,
         cityName: this.deviceInfo.cityName,
         name: this.deviceInfo.nameDevice,
         nameModel: this.deviceInfo.nameModel,
         deviceCategory: this.deviceInfo.deviceCategory,
         registrationCertificatePathFile: this.deviceInfo.registrationCertificatePathFile
       });
      this.deviceInfoUpdated.emit(this.deviceInfo);
      this.loading = false;
    }, err => {
      this.loading = false;
      console.log(err);
      const msg = this.translate.instant('Error while retrieving device info');
      this.widgetsManager.showToastMessage('danger', msg);
      this.close();
    });
  }

  close() {
    if (this.closeEvent) {
      this.closeEvent.emit();
    }
  }

  onSubmit() {
    this.loading = true;

    const objVals = this.deviceInfoForm.value;
    this.deviceInfo.id = objVals.id;
    if (this.selectedFile && this.selectedFile.size > 0) {
      this._deviceInfoSvc.editInfo(this.deviceInfo.id, objVals, this.selectedFile).subscribe(() => {
        this.loading = false;
        this.update();
        const msg = this.translate.instant('Device info modified successfully');
        this.widgetsManager.showToastMessage('success', msg);
      }, err => {
        this.loading = false;
        console.log(err);
        const msg = this.translate.instant('Error while adding device info');
        this.widgetsManager.showToastMessage('danger', msg);
      });
    } else if (this.selectedFile && this.selectedFile.size === 0) {
      this.loading = false;
      const msg = this.translate.instant('Error: file is empty');
      this.widgetsManager.showToastMessage('danger', msg);
    } else {
      this._deviceInfoSvc.editInfo(this.deviceInfo.id, objVals).subscribe(() => {
        this.loading = false;
        this.update();
        const msg = this.translate.instant('Device info modified successfully');
        this.widgetsManager.showToastMessage('success', msg);
      }, err => {
        this.loading = false;
        console.log(err);
        const msg = this.translate.instant('Error while adding device info');
        this.widgetsManager.showToastMessage('danger', msg);
      });
    }
    this.isReadOnly = true;
  }

  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0];
  }

  openEditForm() {
    this.isReadOnly = false
  }

  getFileName(path: string): string {
    if (path) {
      return path.substring(path.lastIndexOf('\\') + 1);
    }
    return '';
  }

  downloadFile(filePath: string) {
    const deviceId = this.deviceInfo.id;

    this._deviceInfoSvc.getRegistrationCertificateFile(deviceId).subscribe(
      (blob: Blob) => {
        if (blob.size === 0) {
          console.error('Error: file is empty');
          return;
        }

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;

        const fileName = filePath.split('\\').pop() || 'downloaded_file';

        a.download = decodeURIComponent(fileName); 
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      },
      error => {
        console.error('Error download file', error);
      }
    );
  }
}